import { ErrorHandler, Inject, Injectable, Injector, Optional } from '@angular/core';

import { Message, MessageType, SeverityType } from './message';
import { NOTIFICATIONS_CONFIG, NotificationsConfig } from './notifications-config';
import { NotificationsService } from './notifications.service';
import { environment } from 'environments/environment';

@Injectable()
export class ErrorHandlerWithNotifications implements ErrorHandler {
  options = {
    showErrorInConsole: true,
    onErrorMessageType: MessageType.Toast
  };

  constructor(
    private injector: Injector,
    @Optional()
    @Inject(NOTIFICATIONS_CONFIG)
    private notificationsConfig: NotificationsConfig
  ) {}

  handleError(error: any): void {
    const notificationService = this.injector.get(NotificationsService);
    if (this.options.showErrorInConsole) {
      this.showErrorInConsole(error);
    }

    notificationService.addNotification({
      type: this.options.onErrorMessageType,
      severity: SeverityType.Error,
      title: 'System Error',
      message:
        environment.production
          ? 'An error occurred and was logged. Please reload the page. Please contact Support if this error persists.' 
          : JSON.stringify(error)          
    } as Message);
  }

  private showErrorInConsole(error: any): void {
    if (console && console.group && console.error) {
      console.group('Error Log');
      console.error(error);
      console.error(error.message);
      console.error(error.stack);
      console.groupEnd();
    }
  }
}
